import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/Store";
import {
  PICKLIST_GROUP_NAME,
  RATE_TYPE,
  WEB_ROLE,
} from "../../../../../common/Constant";
import { fetchPickListByGroupName } from "../../../../../services/CaseInformationApi";
import {
  formatAppointmentDateTime,
  formatDateTime,
} from "../../../../../utils/dateUtils";
import {
  fetchTeamBillingDetails,
  getTeamBillingChangeLog,
  updateTeamBilling,
} from "../../../../../services/BillingAPI";
import AccordionComponent from "../../../../../common/Accordion";
import Loader from "../../../../../common/Loader";
import Snackbar from "../../../../../common/Snackbar";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "react-bootstrap";
import SearchableSingleSelectDropdown from "../../../../../common/SearchableDropdown";
import SearchableMultiSelectDropdown from "../../../../../common/SearchableMultiSelectDropdown";
import NumberInput from "../../../../../common/NumberInput";
import BillingTeamsEditableTable from "../../../Teams/components/BillingTeamsEditableTable";
import FloatingLabelDatepicker from "../../../../../common/DatePicker";
import MultilineTextBox from "../../../../../common/MultilineTextBox";
import ChangeLogDrawer from "./ChangeLogDrawer";
import BillingDataTable from "../BillingDataTable";
import { BILLING_CONFIG_CHANGE_LOG } from "../../actions/constant";

interface UserOptiopn {
  userId?: number;
  usfUlNameRole?: string;
}

const UpdateTeamBillingConfig = ({ onClose, selectedData }: any) => {
  const userID = useSelector((state: RootState) => state.auth.userid);
  const datePickerRef = useRef<HTMLDivElement>(null);
  const [selectedBillingType, setSelectedBillingType] = useState("By Role");
  const [webRoleOptions, setWebRoleOptions] = useState<any[]>([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [userOptions, setUserOptions] = useState<any[]>([]);
  const [userData, setUserData] = useState<UserOptiopn[]>([]);
  const [userSearchQuery, setUserSearchQuery] = useState<string>("");
  const [selectedUser, setSelectedUser] = useState<any>(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [casePriorityOptions, setCasePriorityOptions] = useState<any[]>([]);
  const [selectedCasePriority, setSelectedCasePriority] = useState<
    string | number
  >("");
  const [caseTypeOptions, setCaseTypeOptions] = useState<any[]>([]);
  const [selectedCaseType, setSelectedCaseType] = useState<(string | number)[]>(
    [],
  );
  const [examTypeOptions, setExamTypeOptions] = useState<any[]>([]);
  const [selectedExamType, setSelectedExamType] = useState<(string | number)[]>(
    [],
  );
  const [rateType, setRateType] = useState("Fixed");
  const [currencyOptions, setCurrencyOptions] = useState<any[]>([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyLabel, setSelectedCurrencyLabel] = useState("");
  const [fixedAmount, setFixedAmount] = useState("");
  const [isInputPages, setIsInputPages] = useState<any>("Input");

  const addDays = (date: Date, days: number) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const [effectiveDateFrom, setEffectiveDateFrom] = useState<Date | null>(
    new Date(),
  );
  const [effectiveDateTo, setEffectiveDateTo] = useState<Date | null>(
    addDays(new Date(), 30),
  );
  const [isActive, setIsActive] = useState(true);
  const [comments, setComments] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const [thresholdPageData, setThresholdPageData] = useState<any[]>([]);
  const [thresholdLineData, setThresholdLineData] = useState<any[]>([]);

  const [thresholdErrors, setThresholdErrors] = useState<string[]>([]);
  const [thresholdLineErrors, setThresholdLineErrors] = useState<string[]>([]);

  const [changeLogData, setChangeLogData] = useState<any[]>([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showChangeDrawer, setShowChangeDrawer] = useState(false);
  const [showModalNew, setShowModalNew] = useState<boolean>(false);

  const [createdOn, setCreatedOn] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [configurationBillingKey, setConfigurationBillingKey] = useState<
    string | null
  >("0");
  const [pageThresholdKey, setPageThresholdKey] = useState<string | null>("0");

  const dropdownRef = useRef<HTMLDivElement>(null);
  const billingId =
    selectedData?.billingTeamConfigId ??
    selectedData?.billingConfigId ??
    selectedData?.billingCaseConfigId ??
    null;

  const formattedStringPerPage = thresholdPageData
    .map((d) => `${d.isInputPage},${d.min},${d.max},${d.rate}`)
    .join(" | ");

  const formattedStringPerLine = thresholdLineData
    .map((d) => `${d.min},${d.max},${d.rate}`)
    .join(" | ");

  const params = {
    webRole: {
      groupName: PICKLIST_GROUP_NAME.Web_Application_Role,
      triggerById: userID,
    },
    caseType: {
      groupName: PICKLIST_GROUP_NAME.Case_Review_Type,
      triggerById: userID,
    },
    examType: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Type,
      triggerById: userID,
    },
    casePriority: {
      groupName: PICKLIST_GROUP_NAME.Case_Priority,
      triggerById: userID,
    },
  };

  const currencyData = [
    {
      label: "USD",
      value: "USD",
    },
    {
      label: "INR",
      value: "INR",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const webRoleData = await fetchPickListByGroupName(params.webRole);

        const allowedRoles = [
          WEB_ROLE.Historian,
          WEB_ROLE.Editor,
          WEB_ROLE.Record_Reviewer,
        ];

        const filteredRoles =
          webRoleData?.filter((role: any) =>
            allowedRoles.includes(role.label),
          ) || [];

        setWebRoleOptions(filteredRoles);

        const casePriorityData = await fetchPickListByGroupName(
          params.casePriority,
        );
        setCasePriorityOptions(casePriorityData);
        if (casePriorityData) {
          setSelectedCasePriority(casePriorityData[0]?.value);
        }

        const caseTypeData = await fetchPickListByGroupName(params.caseType);
        setCaseTypeOptions(caseTypeData);

        const examTypeData = await fetchPickListByGroupName(params.examType);
        setExamTypeOptions(examTypeData);

        setCurrencyOptions(currencyData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const parsePageSlabsText = (text: string) => {
    if (!text) return { slabs: [], pageType: "Input" as "Input" | "Output" };

    const rows = text
      .split("|")
      .map((r) => r.trim())
      .filter(Boolean);

    const slabs = rows.map((row) => {
      const [isInput, min, max, rate] = row.split(",");

      return {
        isInputPage: Number(isInput) as 0 | 1,
        min: Number(min),
        max: Number(max),
        rate: Number(rate),
      };
    });

    const pageType = slabs[0]?.isInputPage === 1 ? "Input" : "Output";

    return { slabs, pageType };
  };

  const parseThresholdLineString = (data?: string) => {
    if (!data) return [];

    return data.split("|").map((chunk) => {
      const [min, max, rate] = chunk.trim().split(",");

      return {
        min: Number(min),
        max: Number(max),
        rate: Number(rate),
      };
    });
  };

  const getBillingDetails = async () => {
    try {
      setLoading(true);
      let billingData: any = null;
      let billingConfigId: number | null = null;
      let billingChangeLogData: any = null;

      if (selectedData?.billingTeamConfigId) {
        billingConfigId = selectedData.billingTeamConfigId;
        billingData = await fetchTeamBillingDetails(billingConfigId);
        billingChangeLogData = await getTeamBillingChangeLog(billingConfigId);
      }

      if (!billingData) return;

      if (billingData) {
        setSelectedBillingType(
          selectedData.billingType == "Role" ? "By Role" : "By User",
        );

        setSelectedRole(
          selectedData.billingType == "Role" && billingData.webRoleId
            ? billingData.webRoleId
            : null,
        );

        if (billingData.billingForUserFullName) {
          setSelectedUser({
            userId: billingData.userId ?? null,
            tenantId: billingData.tenantId ?? null,
            usfUlNameRole: billingData.billingForUserFullName,
          });
        }

        setSelectedCasePriority(
          billingData.priorityId ? billingData.priorityId : null,
        );

        setSelectedCaseType(
          billingData.caseTypeIdCsv
            ? billingData.caseTypeIdCsv.split(",").map(Number)
            : [],
        );

        setSelectedExamType(
          billingData.examTypeIdCsv
            ? billingData.examTypeIdCsv.split(",").map(Number)
            : [],
        );

        const getRateType =
          billingData.rateType == "Fixed" && billingData.flatRate > 0
            ? "Fixed"
            : billingData.rateType == "Fixed" && billingData.flatRatePerPage > 0
              ? "Fixed Per Page"
              : billingData.rateType == "Fixed" &&
                  billingData.flatRatePerLine > 0
                ? "Fixed Per Line"
                : billingData.rateType == "PER_PAGE"
                  ? "Per Page"
                  : billingData.rateType == "PER_LINE"
                    ? "Per Line"
                    : "";

        setRateType(getRateType);

        setSelectedCurrency(
          billingData.currencyType ? billingData.currencyType : null,
        );

        const getFixedAmount =
          billingData.rateType == "Fixed" && billingData.flatRate
            ? billingData.flatRate
            : billingData.rateType == "Fixed" && billingData.flatRatePerPage
              ? billingData.flatRatePerPage
              : billingData.rateType == "Fixed" && billingData.flatRatePerLine
                ? billingData.flatRatePerLine
                : "";

        setFixedAmount(getFixedAmount > 0 ? getFixedAmount : "");

        const { slabs, pageType } = parsePageSlabsText(
          billingData.page_slabs_text,
        );

        setIsInputPages(pageType);
        setThresholdPageData(slabs);

        const parsed = parseThresholdLineString(billingData.line_slabs_text);
        setThresholdLineData(parsed);

        setEffectiveDateFrom(
          billingData.effectiveStartDate
            ? billingData.effectiveStartDate
            : null,
        );
        setEffectiveDateTo(
          billingData.effectiveEndDate ? billingData.effectiveEndDate : null,
        );
        setComments(billingData.comments ? billingData.comments : null);

        setCreatedOn(
          billingData.createdDate
            ? formatAppointmentDateTime(billingData.createdDate)
            : "",
        );

        setCreatedBy(
          billingData.createdByName ? billingData.createdByName : "",
        );

        if (billingChangeLogData) {
          const filteredLogData = billingChangeLogData?.filter(
            (item: any) =>
              !["modifieddate", "modifiedby"].includes(
                item.fieldName?.toLowerCase(),
              ),
          );

          setChangeLogData(filteredLogData);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedData) {
      getBillingDetails();
    }
  }, [selectedData]);

  const resetBillingState = () => {
    setThresholdPageData([]);
    setThresholdLineData([]);
    setThresholdErrors([]);
    setThresholdLineErrors([]);
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleConfirmCancelButton = () => {
    if (selectedData) {
      getBillingDetails();
    } else {
      resetBillingState();
    }
    setShowModalNew(false);
  };

  const validateConfiguration = () => {
    const errors = [];

    if (selectedBillingType == "By Role" && !selectedRole) {
      errors.push("Please select User Role.");
    }

    if (selectedBillingType == "By User" && !selectedUser) {
      errors.push("Please select User Name.");
    }

    if (!selectedCaseType || selectedCaseType?.length === 0) {
      errors.push("Case Type is mandatory.");
    }

    if (!selectedExamType || selectedExamType?.length === 0) {
      errors.push("Exam Type is mandatory.");
    }

    if (!selectedCurrency || selectedCurrency?.length === 0) {
      errors.push("Currency is mandatory.");
    }
    if (
      rateType == "Fixed" ||
      rateType == "Fixed Per Page" ||
      rateType == "Fixed Per Line"
    ) {
      if (selectedCurrency && !fixedAmount) {
        errors.push("Amount is mandatory.");
      }

      if (selectedCurrency) {
        if (
          fixedAmount === null ||
          fixedAmount === undefined ||
          fixedAmount === "" ||
          Number(fixedAmount) === 0
        ) {
          errors.push("Amount cannot be zero.");
        }
      }
    }

    if (rateType == "Per Page") {
      if (!thresholdPageData) {
        errors.push("Please Add atleast one slab for per page");
      }
    }

    if (rateType == "Per Line") {
      if (!thresholdLineData) {
        errors.push("Please Add atleast one slab for per line");
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const validateThreshold = () => {
    const errors = [];

    if (rateType == "Per Page") {
      if (thresholdErrors.length > 0) {
        errors.push(...thresholdErrors);
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const validateLineThreshold = () => {
    const errors = [];

    if (rateType == "Per Line") {
      if (thresholdLineErrors.length > 0) {
        errors.push(...thresholdLineErrors);
      }
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };
  useEffect(() => {
    if (thresholdErrors.length > 0) {
      validateThreshold();
    }
  }, [thresholdErrors]);

  useEffect(() => {
    if (thresholdLineErrors.length > 0) {
      validateLineThreshold();
    }
  }, [thresholdLineErrors]);

  const getRateTypeForPayload = (rateType: string) => {
    switch (rateType) {
      case "Fixed":
      case "Fixed Per Page":
      case "Fixed Per Line":
        return RATE_TYPE.FLAT;
      case "Per Page":
        return RATE_TYPE.PER_PAGE;
      case "Per Line":
        return RATE_TYPE.PER_LINE;
      default:
        return rateType;
    }
  };

  const handleSave = async () => {
    if (!validateConfiguration()) return;
    setLoading(true);
    try {
      const payload = {
        billingTeamConfigId: selectedData?.billingTeamConfigId,
        teamId: selectedData?.teamId,
        webRoleId: selectedRole ? selectedRole : null,
        userId: selectedUser ? selectedUser.userId : null,
        priorityId: Number(selectedCasePriority),
        effectiveStartDate: effectiveDateFrom
          ? formatDateTime(effectiveDateFrom)
          : null,
        effectiveEndDate: effectiveDateTo
          ? formatDateTime(effectiveDateTo)
          : null,
        caseTypeIdCsv: selectedCaseType.join(","),
        examTypeIdCsv: selectedExamType.join(","),
        rateType: getRateTypeForPayload(rateType),
        currencyType: selectedCurrency,
        flatRate: rateType == "Fixed" ? fixedAmount : 0,
        flatRatePerPage: rateType == "Fixed Per Page" ? fixedAmount : 0,
        flatRatePerLine: rateType == "Fixed Per Line" ? fixedAmount : 0,
        isPageThresholdAppl: rateType == "Per Page" ? 1 : 0,
        comments: comments,
        billingConfigStatus: isActive ? 1 : 0,
        modifiedBy: userID,
        createdBy: userID,
        pageSlabsText: rateType == "Per Page" ? formattedStringPerPage : null,
        lineSlabsText: rateType == "Per Line" ? formattedStringPerLine : null,
      };

      const response = await updateTeamBilling(payload);

      if (response.isSuccess) {
        setSnackbarMessage("Team Billing has been updated successfully");
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          onClose();
        }, 1000);
      }
    } catch (error) {
      setSnackbarMessage("An unexpected error occurred.");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenChangeDrawer = async () => {
    if (selectedData) {
      setShowTooltip(false);
      setShowChangeDrawer(true);
    }
  };

  const handleCloseChangeDrawer = () => {
    setShowChangeDrawer(false);
  };

  const handleAccordionSelect = (key: string | null) => {
    if (configurationBillingKey === key) {
      return;
    }
    setConfigurationBillingKey(key || "0");
  };

  const configurationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={configurationBillingKey}
      onSelect={handleAccordionSelect}
    />
  );

  const thresholdAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={pageThresholdKey}
      onSelect={(key) => setPageThresholdKey(key as string)}
    />
  );

  const fixedSelected = ["Fixed", "Fixed Per Page", "Fixed Per Line"].includes(
    rateType,
  );
  return (
    <div>
      {" "}
      <div className="mt-4 mb-5">
        <Loader isLoading={loading} />
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />{" "}
        {configurationAccordion([
          {
            title: "Configure Billing",
            content: (
              <>
                <Row className="align-items-center mt-0">
                  <div className="col-md-4 col-xxl-4 d-flex align-items-center gap-5">
                    {/* Billing Label */}
                    <Col xs="auto" className="fw-semibold form-label mb-0">
                      Billing
                    </Col>

                    {/* Toggle Buttons */}
                    <Col xs="auto" className="px-2">
                      <ToggleButtonGroup
                        type="radio"
                        name="billingType"
                        value={selectedBillingType}
                        className="appointment-ui d-flex adjust adjust_pills_xs"
                      >
                        <ToggleButton
                          id="billing-role"
                          variant="outline-secondary"
                          value="By Role"
                          className="px-4"
                          disabled={selectedData}
                        >
                          By Role
                        </ToggleButton>

                        <ToggleButton
                          id="billing-user"
                          variant="outline-secondary"
                          value="By User"
                          className="px-3"
                          disabled={selectedData}
                        >
                          By User
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </Col>
                  </div>

                  <div className="col-md-3">
                    {/* Conditional Field */}
                    {selectedBillingType === "By Role" ? (
                      <Col className="selection_dropdown">
                        <SearchableSingleSelectDropdown
                          label="Role"
                          value={selectedRole}
                          options={webRoleOptions}
                          onChange={(e) => setSelectedRole(e.target.value)}
                          name="webRoleID"
                          required={true}
                          disabled={selectedData}
                        />
                      </Col>
                    ) : (
                      <Col>
                        <div className="form-floating" ref={dropdownRef}>
                          <input
                            type="text"
                            name="User Name"
                            className="form-control zipcodeDetailsOverlay"
                            placeholder="Search User"
                            maxLength={50}
                            value={
                              selectedUser
                                ? selectedUser.usfUlNameRole
                                : userSearchQuery
                            }
                            autoComplete="off"
                            required
                            disabled={selectedData}
                          />
                          <label>
                            User Name <span className="text-danger">*</span>
                          </label>
                        </div>
                      </Col>
                    )}
                  </div>
                </Row>

                <Row className="align-items-center mt-3">
                  <div className="col-md-6 col-xxl-4">
                    <div className="d-flex align-items-center gap-2">
                      <Col
                        xs="auto"
                        className="fw-semibold ps-1 form-label-fixed mb-0"
                      >
                        Case Priority
                      </Col>

                      <Col xs="auto">
                        <ToggleButtonGroup
                          type="radio"
                          name="casePriority"
                          value={selectedCasePriority}
                          className="appointment-ui adjust_pills_xs"
                        >
                          {casePriorityOptions.map((opt) => (
                            <ToggleButton
                              key={opt.value}
                              id={`priority-${opt.value}`}
                              variant="outline-secondary"
                              value={opt.value}
                              disabled={selectedData}
                              className="px-3"
                            >
                              {opt.label}
                            </ToggleButton>
                          ))}
                        </ToggleButtonGroup>
                      </Col>
                    </div>
                  </div>

                  <Col sm={3} className="selection_dropdown">
                    <SearchableMultiSelectDropdown
                      label="Case Type"
                      name="caseType"
                      options={caseTypeOptions}
                      values={selectedCaseType}
                      onChange={(e, name, values) =>
                        setSelectedCaseType(values)
                      }
                      disabled={selectedData}
                      required
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableMultiSelectDropdown
                      label="Exam Type"
                      name="examType"
                      options={examTypeOptions}
                      values={selectedExamType}
                      disabled={selectedData}
                      onChange={(e, name, values) =>
                        setSelectedExamType(values)
                      }
                      required
                    />
                  </Col>
                </Row>
                <Row className="align-items-center mt-3">
                  <div className="col-md-6 col-xxl-4">
                    <div className="rate-type-wrapper">
                      {/* Fixed */}
                      <div className="rate-type-block adjust_spacingToggle">
                        <div className="rate-type-label">
                          Rate Type (Fixed)
                          <span style={{ color: "#0092d5" }}>
                            {fixedSelected ? " Selected" : ""}
                          </span>
                        </div>

                        <ToggleButtonGroup
                          type="radio"
                          name="rateTypeMain"
                          value={rateType}
                          // onChange={handleRateTypeChange}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="fixed-rate"
                            variant="outline-secondary"
                            value="Fixed"
                            disabled={selectedData}
                            className="px-3"
                          >
                            Fixed
                          </ToggleButton>

                          <ToggleButton
                            id="per-page-main"
                            variant="outline-secondary"
                            value="Fixed Per Page"
                            disabled={selectedData}
                            className="px-3"
                          >
                            Per Page
                          </ToggleButton>

                          <ToggleButton
                            id="per-line-main"
                            variant="outline-secondary"
                            value="Fixed Per Line"
                            className="px-3"
                            disabled={selectedData}
                          >
                            Per Line
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </div>

                      {/* Pipe */}
                      <div className="rate-type-pipe">||</div>

                      {/* Slab */}
                      <div className="rate-type-block">
                        <div className="rate-type-label">
                          Rate Type (Slab)
                          <span style={{ color: "#0092d5" }}>
                            {!fixedSelected ? " Selected" : ""}
                          </span>
                        </div>

                        <ToggleButtonGroup
                          type="radio"
                          name="rateTypeSlab"
                          value={rateType}
                          // onChange={handleRateTypeChange}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="per-page-slab"
                            variant="outline-secondary"
                            value="Per Page"
                            className="px-3"
                            disabled={selectedData}
                          >
                            Per Page
                          </ToggleButton>

                          <ToggleButton
                            id="per-line-slab"
                            variant="outline-secondary"
                            value="Per Line"
                            className="px-3"
                            disabled={selectedData}
                          >
                            Per Line
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </div>
                    </div>
                  </div>

                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Currency"
                      value={selectedCurrency}
                      options={currencyOptions}
                      disabled={selectedData}
                      name="currencyID"
                      required={true}
                    />
                  </Col>
                  {rateType == "Fixed" ||
                  rateType == "Fixed Per Page" ||
                  rateType == "Fixed Per Line" ? (
                    <Col sm={3}>
                      <NumberInput
                        label="Amount"
                        name="amount"
                        value={fixedAmount}
                        onChange={(e) => setFixedAmount(e.target.value)}
                        allowDecimal={true}
                        limit={[8, 2]}
                        disabled={selectedData}
                        showAmountLabel={true}
                        amountLabel={selectedCurrencyLabel}
                      />
                    </Col>
                  ) : null}
                  {rateType === "Per Page" && (
                    <>
                      <Col
                        sm="3"
                        className="fw-semibold ps-1 form-label-fixed d-flex align-items-center adjust_spacingToggle"
                      >
                        Slab Apply on Pages
                        <ToggleButtonGroup
                          type="radio"
                          name="inputPagesType"
                          value={isInputPages}
                          className="appointment-ui adjust_pills_xs"
                        >
                          <ToggleButton
                            id="input-page"
                            variant="outline-secondary"
                            value="Input"
                            className="px-3"
                            disabled={selectedData}
                          >
                            Input
                          </ToggleButton>

                          <ToggleButton
                            id="output-page"
                            variant="outline-secondary"
                            value="Output"
                            className="px-3"
                            disabled={selectedData}
                          >
                            Output
                          </ToggleButton>
                        </ToggleButtonGroup>
                      </Col>
                    </>
                  )}
                </Row>

                {rateType == "Per Page" ? (
                  <Row className="align-items-center mt-3">
                    {thresholdAccordion([
                      {
                        title:
                          isInputPages === "Input"
                            ? "Input Page Threshold"
                            : "Output Page Threshold",
                        content: (
                          <BillingTeamsEditableTable
                            isInputPages={isInputPages}
                            value={thresholdPageData}
                            onChange={setThresholdPageData}
                            onValidationError={setThresholdErrors}
                            isCaseBilling={!!selectedData?.billingCaseConfigId}
                            disabled={true}
                          />
                        ),
                      },
                    ])}
                  </Row>
                ) : null}
                {rateType == "Per Line" ? (
                  <Row className="align-items-center mt-3">
                    {thresholdAccordion([
                      {
                        title: "Line Threshold",
                        content: (
                          <BillingTeamsEditableTable
                            isInputPages={isInputPages}
                            value={thresholdPageData}
                            onChange={setThresholdPageData}
                            onValidationError={setThresholdErrors}
                            isCaseBilling={!!selectedData?.billingCaseConfigId}
                            disabled={true}
                          />
                        ),
                      },
                    ])}
                  </Row>
                ) : null}
                <Row className="align-items-center mt-3">
                  <div className="col-md-3  col-xxl-2">
                    <FloatingLabelDatepicker
                      ref={datePickerRef}
                      label="Effective Date From"
                      name="effectiveDateFrom"
                      value={effectiveDateFrom}
                      onChange={(date: Date | null) => {
                        setEffectiveDateFrom(date);
                      }}
                      required
                      dateFormat="MM/dd/yyyy"
                      maxDate={effectiveDateTo || undefined}
                      disabled={selectedData}
                    />
                  </div>

                  <div className="col-md-3  col-xxl-2">
                    <FloatingLabelDatepicker
                      ref={datePickerRef}
                      label="Effective Date To"
                      name="effectiveDateTo"
                      value={effectiveDateTo}
                      onChange={(date: Date | null) => {
                        setEffectiveDateTo(date);
                      }}
                      dateFormat="MM/dd/yyyy"
                      minDate={effectiveDateFrom || new Date()}
                      canClear={true}
                      disabled={selectedData}
                    />
                  </div>
                  <div className="col-md-4 col-sm-6">
                    <div className="d-flex align-items-center toggle-btn">
                      <span className="me-3 fw-semibold">Status</span>

                      <Form.Check
                        type="switch"
                        id="sort-switch"
                        checked={isActive}
                        disabled={selectedData}
                      />
                      <span className="ms-2">
                        {isActive ? "Active" : "In Active"}
                      </span>
                    </div>
                  </div>
                </Row>
                <Col
                  sm={12}
                  className="mt-3 notemultiline notemultilinerushnote  mb-3"
                >
                  <MultilineTextBox
                    label="Comments"
                    name="comments"
                    value={comments}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(" ")) return;
                      value = value?.trimStart();
                      value = value.replace(/ {2,}/g, " ");
                      setComments(value);
                    }}
                    maxLength={100}
                    disabled={selectedData}
                  />
                </Col>
                <Row className="mt-3 mb-3">
                  <Col sm={12} className="d-flex align-items-center">
                    {changeLogData?.length > 0 && selectedData && (
                      <OverlayTrigger
                        show={showTooltip}
                        placement="auto"
                        trigger={["hover", "focus"]}
                        delay={{ show: 200, hide: 100 }}
                        overlay={
                          <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                            Logs
                          </Tooltip>
                        }
                      >
                        <div className="d-flex">
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center mx-2"
                            onClick={handleOpenChangeDrawer}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          >
                            <span className="material-icons">description</span>
                          </Button>
                        </div>
                      </OverlayTrigger>
                    )}

                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center me-auto btn-text-border"
                      onClick={onClose}
                    >
                      <span className="material-icons me-1">arrow_back</span>
                      Back
                    </Button>

                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center"
                      onClick={handleCancelButton}
                      disabled={selectedData}
                    >
                      <span className="material-icons me-1">close</span>
                      Cancel
                    </Button>

                    <Button
                      type="submit"
                      variant="primary"
                      className="ms-3 d-flex align-items-center"
                      onClick={handleSave}
                      disabled={selectedData}
                    >
                      <span className="material-icons me-1">save</span>
                      Save
                    </Button>
                  </Col>
                </Row>
              </>
            ),
          },
        ])}
        <Modal show={showModalNew} onHide={handleCloseModalNew}>
          <Modal.Body className="fw-bold text-left modelheading ">
            <div>Are you sure you want to cancel?</div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModalNew}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleConfirmCancelButton}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>
        <ChangeLogDrawer
          title={"Change Log"}
          open={showChangeDrawer}
          onClose={handleCloseChangeDrawer}
          placement="bottom"
          data={changeLogData}
          createdOn={createdOn}
          createdBy={createdBy}
        >
          <BillingDataTable
            headers={BILLING_CONFIG_CHANGE_LOG}
            rows={changeLogData}
            isLogTable={true}
          />
        </ChangeLogDrawer>
      </div>
    </div>
  );
};

export default UpdateTeamBillingConfig;
